import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Spinner from 'web/components/Spinner';
import Layout from 'web/components/Layout';
import CutIcon from 'web/assets/images/cut-icon.png'
import ReferralCodeHand from 'web/assets/images/referral-code-hand.png'
import ReferralCodeBg from 'web/assets/images/referral-code.webp'
import FbLink from 'web/assets/images/fb-link.png'
import { CopyToClipboard } from 'react-copy-to-clipboard';
import Button from "web/components/Button";
import AlertModal from 'web/components/AlertModal';

import { fetchReferralApi, sendInviteViaEmailApi, sendInviteViaLinkApi } from 'redux/actions/referral'

import styled from 'styled-components';

const Referral = (props) => {
  const [referralCode, setReferralCode] = useState(undefined)
  const [copied, setCopied] = useState(false)
  const [shareLinkValue, setShareLinkValue] = useState('')
  const [shareEmailValue, setShareEmailValue] = useState('')
  const token = localStorage.getItem('token');
  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState('');
  const toggleModal = () => setModal(!modal);
  const [urlSearchParams, setURLSearchParams] = useState();
  let dispatch = useDispatch();
  const loaderVisible = useSelector(
    (state) => state.appReducer.loaderVisible
  );

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    fetchReferralCode()
  }, [])

  useEffect(() => {
    if (copied) {
      setInterval(() => {
        setCopied(false)
      }, [1500])
    }
  }, [copied])

  const fetchReferralCode = async () => {
    let response = await dispatch(fetchReferralApi(token));
    if (response.status === 'SUCCESS') {
      setReferralCode(response.payload)
    }
  }

  const sendInviteViaEmail = async () => {
    let response = await dispatch(sendInviteViaEmailApi(shareEmailValue, token));
    if (response.status === 'SUCCESS') {
      setShareEmailValue('')
      setModalContent(response.message);
      toggleModal();
    } else {
      setModalContent(response.message);
      toggleModal();
    }
  }

  const sendInviteViaLink = async () => {
    let response = await dispatch(sendInviteViaLinkApi(shareLinkValue, token));
    if (response.status === 'SUCCESS') {
      setShareLinkValue('')
      setModalContent(response.message);
      toggleModal();
    } else {
      setModalContent(response.message);
      toggleModal();
    }
  }

  return (
    <>
      <Layout topBarViewMobile={"hide"}>
        {loaderVisible && <Spinner />}
        <Container>
          <TextWrapper>
            <h1>Referral code</h1>
            <h2>INVITE YOUR FRIENDS TO PALLETTRADER</h2>
              {referralCode !== undefined &&
                <h6>
                {`When ${referralCode.MinimumReferralRequired} members successfully register and sign into the PalletTrader,
                  they will get a free subscription of ${referralCode.InvitedBenefitDuration} 
                  ${referralCode.InvitedBenefitType === 'DAY' ? 'day(s)' : referralCode.InvitedBenefitType === 'MONTH' ? 'month(s)' : 'year(s)'} 
                  and you will get a free subscription of ${referralCode.OwnerBenifitDuration} 
                  ${referralCode.OwnerBenifitType === 'DAY' ? 'day(s)' : referralCode.OwnerBenifitType === 'MONTH' ? 'month(s)' : 'year(s)'}`}
                </h6>}
              <UniqueCode>
                <div className='unique-code-title'>Your Unique Code</div>
                <CopySection>
                  <p>{referralCode && referralCode.referralCode}</p>
                  <CopyToClipboard text={referralCode && referralCode.referralCode}
                    onCopy={() => setCopied(true)}>
                    <img src={CutIcon} className='cut-icon' alt='cut-icon' />
                  </CopyToClipboard>
                  {copied && <p className='copy'>Copied!</p>}
                </CopySection>
              </UniqueCode>
              <MyReferral>
                <h6>My Referrals</h6>
                <p><b>{`${referralCode !== undefined ? referralCode.joined : ''}/${referralCode !== undefined ? referralCode.total : ''}`}</b> Members have registered using your Referral Code</p>
              </MyReferral>
              <ReferralCodeHandImage>
                <img src={ReferralCodeHand} alt='ReferralCodeHand' />

              </ReferralCodeHandImage>
              <LinkShareWrapper>
                <div className='link-box'>
                  <h4>Share your link</h4>
                  <CopySection>
                      <p
                        title={referralCode && `${process.env.REACT_APP_WEB_URL}Registration/${referralCode.referralCode}`}>{referralCode && `${process.env.REACT_APP_WEB_URL}Registration/${referralCode.referralCode}`}</p>
                    <CopyToClipboard text={referralCode && `${process.env.REACT_APP_WEB_URL}Registration/${referralCode.referralCode}`}
                      onCopy={() => setCopied(true)}>
                      <img src={CutIcon} className='cut-icon' alt='cut-icon' />
                    </CopyToClipboard>
                    {copied && <p className='copy'>Copied!</p>}
                  </CopySection>

                </div>
                <div className='link-box'>
                  <h4>Share via email</h4>
                  <input value={shareEmailValue} onChange={e => setShareEmailValue(e.target.value)} />
                  <Button type="app-green-button"
                    disabled={!(shareEmailValue.includes('.') && shareEmailValue.includes('@'))}
                    handleClick={sendInviteViaEmail}
                  >
                    Send Invite
                  </Button>
                </div>
                <div className='link-box'>
                  <h4>Share on</h4>
                  <img className='fb-link' src={FbLink} alt='fb-link' />
                </div>

              </LinkShareWrapper>
            </TextWrapper>
          </Container>
        </Layout>

        <AlertModal
          isOpen={modal}
          toggle={toggleModal}
          title=''
          content={modalContent}
        />

    </>
  )
};

export default Referral;

const Container = styled.div`
      max-width: 1411px;
          padding: 30px 85px;
          width: 100%;
          margin: 0 auto;
          background-image: url(${ReferralCodeBg});
          background-repeat: no-repeat;
          background-position: 100% 38%;
          background-size: 56%;
          @media (max-width:1250px) {
            padding: 30px 15px;
          }
          @media (max-width:850px) {
          background-image: none;
          }

      `
const TextWrapper = styled.div`
      h1 {
            font-size: 34px;
            color: #1a5c79;
            font-family: 'latobold';
            margin-bottom: 70px;
            position: relative;
            ::after {
              content: '';
          width: calc(100% - 217px);
          height: 1.5px;
          background-color: #1a5c798a;
          display: inline-block;
          position: absolute;
          top: 23px;
          right: 0;
            }
          }
          h2 {
            color: #323538;
            line-height: 1.21;
            font-size: 33px;
            font-family: 'latoblack';
            margin-bottom: 23px;
          }
          h6 {
            color: #323538;
            line-height: 1.23;
            font-size: 22px;
            font-family: 'latoregular';
            margin-bottom: 45px;
            max-width: 694px;
          }
          @media (max-width:850px) {
            h1 {
            margin-bottom: 30px;
          }
          }
          @media (max-width:650px) {
            h1 {
            margin-bottom: 28px;
            font-size: 30px;
          }
          h2 {
            margin-bottom: 28px;
            font-size: 28px;

          }
          h6 {
            margin-bottom: 18px;
          }
          }
      `
const UniqueCode = styled.div`
          max-width: 554px;
          width: 100%;
          padding: 7px 0;
          display: grid;
          grid-template-columns: 1fr 1fr;
          align-items: center;
          border-radius: 10px;
        backdrop-filter: blur(50px);
        link-box-shadow: 1px 2px 7px 0 rgba(0, 0, 0, 0.16);
        background-color: #e9e9e95c;
        margin-bottom: 38px;
        gap: 10px;
        .unique-code-title {
          position: relative;
          white-space: nowrap;
          ::after {
          content: '';
          height: 100%;
          width: 1px;
          background: #3d3b3b;
          display: inline-flex;
          position: absolute;
          right: 0;
          }
        }
        
        /* span {
          height: 39px;
          background: #3d3b3b;
          width: 1px;
          display: inline-flex;
        } */
          > div {
            font-size: 26px;
        font-family: 'latoregular';
          padding: 7px 20px;
          display: flex;
          align-items: center;
          gap: 5px;
          min-height: 54px;
          }
          @media (max-width:583px) {
            > div {
              font-size: 16px;
              
            }
          }
          @media (max-width:450px) {
            display: flex;
    flex-direction: column;
    gap: 0;
            > div {
              display: flex;
              align-items: center;
              justify-content: center;
            gap: 0;
            width: 100%;
            }
            .unique-code-title {
        
          ::after {
          height: 1px;
          width: 70%;
          left: 0;
          margin: 0 auto;
          bottom: 0;
          }
        }
          }
      `
const ReferralCodeHandImage = styled.div`
      max-width: 554px;
          width: 100%;
          display: flex;
          img {
            margin: 0 auto;
            max-width: 413px;
            width: 100%;
          }
      `
const LinkShareWrapper = styled.div`
        border-top: solid 1px #38393a;
        display: flex;
          justify-content: space-between;
          gap: 20px 60px;
          padding: 29px 0;
          .fb-link {
            cursor: pointer;
          }
        .link-box {
            flex: 1;
            padding: 15px 0;
            position: relative;
            width:33%;
            input {
              border: solid 1px #3586b8;
          height: 42px;
          border-radius: 5px;
          width: 100%;
          margin-bottom: 10px;
          padding: 0 18px;
            }
            h4 {
              font-size: 28px;
              line-height: 34px;
              font-family: 'latobold';
              margin-bottom: 17px;
              color: #575e63;
            }
            button {
              width: 100%;
            }
            ::after {
            content: '';
              display: inline-flex;
              height: 100%;
              width: 1px;
              background-color: #38393a;
              position: absolute;
              right: -30px;
              top: 0;
            }
            :last-child {
              ::after {
                display: none;
              }
            }
          }
          @media (max-width:650px) {
          flex-direction: column;
          .link-box  {
            width: 100%;
            h4 {
              font-size: 24px;
            }
          }
          }
          
          
      `

const MyReferral = styled.div`
          max-width: 553px;
        padding: 5px;
        padding: 10px 20px;
        background-color: #e9e9e95c;
        border-radius: 10px;
        margin-bottom: 30px;
        h6 {
          margin: 0;
        font-size: 28px;
        font-size: 26px;
        font-family: 'latoregular';
        line-height: 30px;
        }
      `
const CopySection = styled.div`
      font-family: 'latobold';
            position: relative;
            display: flex;
            align-items: center;
            padding-right: 42px !important;
            overflow: hidden;
            min-height: 42px;
            .cut-icon {
              position: absolute;
              right: 15px;
            }
            > p {
              white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
            }
            .copy {
              position: absolute;
              right: 0;
              top: 0;
              font-size: 12px;
              width: 64px;
              height: 30px;
              display: flex;
              align-items: center;
              justify-content: center;
              background: rgb(97, 176, 31);
              border-radius: 6px;
              color: white;
              padding:2px;
        @media (max-width:583px) {
            > p {
              font-size: 16px;
            }
          }
    }
      `